import React from 'react';

const TwemojiLicense = props => {
  return (
    <div {...props}>
      Copyright 2019 Twitter, Inc and other contributors.
      <br /> Graphics licensed under{' '}
      <a
        href="https://creativecommons.org/licenses/by/4.0/"
        target="_blank"
        rel="noreferrer noopener"
      >
        CC-BY 4.0
      </a>
      .
    </div>
  );
};

export default TwemojiLicense;
